export { TCSPromotionSearchScope } from './generated/TCSPromotionSearchScope.js';
